// extracted by mini-css-extract-plugin
export var actionButton = "_fi-t";
export var buttonContainer = "_fi-0";
export var buttonContainer2 = "_fi-1";
export var buttonSection = "_fi-2";
export var details = "_fi-3";
export var dropdownItem = "_fi-5";
export var dropdownItemsContainer = "_fi-4";
export var fileInput = "_fi-r";
export var headerButton = "_fi-6";
export var icon = "_fi-7";
export var input = "_fi-8";
export var macroListItem = "_fi-9";
export var mainContent = "_fi-a";
export var microText = "_fi-b";
export var modal = "_fi-w";
export var optionsButton = "_fi-c";
export var paperclip = "_fi-s";
export var pillContent = "_fi-d";
export var preview = "_fi-e";
export var preview2 = "_fi-f";
export var quillEditor = "_fi-q";
export var selectedMacro = "_fi-g";
export var sidebar = "_fi-h";
export var sidebarHeader = "_fi-j";
export var sidebarList = "_fi-i";
export var sidebarListItem = "_fi-k";
export var sidebarSearch = "_fi-l";
export var snoozeDurationWrapper = "_fi-v";
export var statusPillContainer = "_fi-m";
export var tagsContainer = "_fi-n";
export var unselectedMacro = "_fi-o";
export var variable = "_fi-u";
export var wrapper = "_fi-p";